/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommentDto } from './CommentDto';
import {
    CommentDtoFromJSON,
    CommentDtoFromJSONTyped,
    CommentDtoToJSON,
    CommentDtoToJSONTyped,
} from './CommentDto';

/**
 * 
 * @export
 * @interface CursorPagedCommentDto
 */
export interface CursorPagedCommentDto {
    /**
     * 
     * @type {Array<CommentDto>}
     * @memberof CursorPagedCommentDto
     */
    content: Array<CommentDto>;
    /**
     * Cursor to fetch the next page (createdAt of the last item in this page). Null when no more pages.
     * @type {Date}
     * @memberof CursorPagedCommentDto
     */
    nextCursorCreatedAt?: Date | null;
    /**
     * Whether more comments exist after this page.
     * @type {boolean}
     * @memberof CursorPagedCommentDto
     */
    hasMore: boolean;
}

/**
 * Check if a given object implements the CursorPagedCommentDto interface.
 */
export function instanceOfCursorPagedCommentDto(value: object): value is CursorPagedCommentDto {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('hasMore' in value) || value['hasMore'] === undefined) return false;
    return true;
}

export function CursorPagedCommentDtoFromJSON(json: any): CursorPagedCommentDto {
    return CursorPagedCommentDtoFromJSONTyped(json, false);
}

export function CursorPagedCommentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CursorPagedCommentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(CommentDtoFromJSON)),
        'nextCursorCreatedAt': json['nextCursorCreatedAt'] == null ? undefined : (new Date(json['nextCursorCreatedAt'])),
        'hasMore': json['hasMore'],
    };
}

export function CursorPagedCommentDtoToJSON(json: any): CursorPagedCommentDto {
    return CursorPagedCommentDtoToJSONTyped(json, false);
}

export function CursorPagedCommentDtoToJSONTyped(value?: CursorPagedCommentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(CommentDtoToJSON)),
        'nextCursorCreatedAt': value['nextCursorCreatedAt'] == null ? undefined : ((value['nextCursorCreatedAt'] as any).toISOString()),
        'hasMore': value['hasMore'],
    };
}

